import React, { type PropsWithChildren } from 'react';

type ShowGroupDetailView =
  | { shouldShow: false }
  | { shouldShow: true; groupId: string };

interface ShowGroupDetailViewContext {
  showGroupDetailView: ShowGroupDetailView;
  setShowGroupDetailView: (groupId: string | null) => void;
}
const context = React.createContext<ShowGroupDetailViewContext>({
  showGroupDetailView: { shouldShow: false },
  setShowGroupDetailView: () => {},
});

context.displayName = 'ShowGroupDetailViewContext';

export const ShowGroupDetailViewProvider = ({
  initialState,
  children,
}: PropsWithChildren<{ initialState?: string | null }>) => {
  const [activeGroupId, setActiveGroupId] = React.useState<string | null>(
    initialState ?? null,
  );

  const showGroupDetailView: ShowGroupDetailView = activeGroupId
    ? { shouldShow: true, groupId: activeGroupId }
    : { shouldShow: false };

  const setShowGroupDetailView = React.useCallback(
    (groupId: string | null) => {
      setActiveGroupId(groupId);
    },
    [setActiveGroupId],
  );

  return (
    <context.Provider value={{ setShowGroupDetailView, showGroupDetailView }}>
      {children}
    </context.Provider>
  );
};

export const useShowGroupDetailView = () => React.useContext(context);
